import { defineStore } from "pinia";
import { ref, computed } from "vue";
export const useStore = defineStore("main", () => {
    // State
    const free_text = ref(null);
    const mongo_text = ref(null);
    const creator_usernames = ref([]);
    const base_uris = ref([]);
    const tags = ref([]);
    const uploaded_by = ref([]);
    const current_dataset_index = ref(0);
    const current_dataset = ref(null);
    const current_dataset_manifest = ref(null);
    const current_dataset_readme = ref(null);
    const current_dataset_annotations = ref(null);
    const current_dataset_tags = ref(null);
    const num_filtered = ref(0);
    const update_current_Per_Page = ref(10);
    const current_pageNumber = ref(1);
    const selected_sort_option = ref("-frozen_at");
    const server_versions = ref({});
    const lookup_url = ref(null);
    // Computed
    const hasSignedUrlPlugin = computed(() => !!server_versions.value.dserver_signed_url_plugin);
    // Actions
    function updateFreeText(value) {
        free_text.value = value;
    }
    function updateMongoText(value) {
        mongo_text.value = value;
    }
    function updateCreatorUsernames(value) {
        creator_usernames.value = value;
    }
    function updateBaseUris(value) {
        base_uris.value = value;
    }
    function updateTags(value) {
        tags.value = value;
    }
    function updateUploadedBy(value) {
        uploaded_by.value = value;
    }
    function updateCurrentDatasetIndex(index) {
        current_dataset_index.value = index;
    }
    function updateCurrentPageNumber(pageNumber) {
        current_pageNumber.value = pageNumber;
    }
    function updateCurrentDataset(dataset) {
        current_dataset.value = dataset;
    }
    function updateCurrentDatasetManifest(manifest) {
        current_dataset_manifest.value = manifest;
    }
    function updateCurrentDatasetReadme(readme) {
        current_dataset_readme.value = readme;
    }
    function updateCurrentDatasetAnnotations(annotations) {
        current_dataset_annotations.value = annotations;
    }
    function updateCurrentDatasetTags(value) {
        current_dataset_tags.value = value;
    }
    function updateNumFiltered(value) {
        num_filtered.value = value;
    }
    function updateCurrentPerPage(perpage) {
        update_current_Per_Page.value = perpage;
    }
    function updateSelectedSortOption(value) {
        selected_sort_option.value = value;
    }
    function updateServerVersions(versions) {
        server_versions.value = versions;
    }
    function updateLookupUrl(value) {
        lookup_url.value = value;
    }
    function clearAll() {
        free_text.value = null;
        mongo_text.value = null;
        creator_usernames.value = [];
        tags.value = [];
        base_uris.value = [];
        uploaded_by.value = [];
    }
    return {
        // State
        free_text,
        mongo_text,
        creator_usernames,
        base_uris,
        tags,
        uploaded_by,
        current_dataset_index,
        current_dataset,
        current_dataset_manifest,
        current_dataset_readme,
        current_dataset_annotations,
        current_dataset_tags,
        num_filtered,
        update_current_Per_Page,
        current_pageNumber,
        selected_sort_option,
        server_versions,
        lookup_url,
        // Computed
        hasSignedUrlPlugin,
        // Actions
        updateFreeText,
        updateMongoText,
        updateCreatorUsernames,
        updateBaseUris,
        updateTags,
        updateUploadedBy,
        updateCurrentDatasetIndex,
        updateCurrentPageNumber,
        updateCurrentDataset,
        updateCurrentDatasetManifest,
        updateCurrentDatasetReadme,
        updateCurrentDatasetAnnotations,
        updateCurrentDatasetTags,
        updateNumFiltered,
        updateCurrentPerPage,
        updateSelectedSortOption,
        updateServerVersions,
        updateLookupUrl,
        clearAll,
    };
});
